import { render, staticRenderFns } from "./tradesmanWorks.vue?vue&type=template&id=3fcaad22&scoped=true&"
import script from "./tradesmanWorks.vue?vue&type=script&lang=js&"
export * from "./tradesmanWorks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcaad22",
  null
  
)

export default component.exports